new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    }
});

//sliders
$(document).ready(function () {

    waitForElementToExist('#faixa-cupom').then(element => {
        const faixCupom = document.querySelector('.faixa-cupom');

        if (faixCupom) {
            const formButton = document.querySelector('.faixa-cupom-form button');
            const spanElement = document.getElementById("valorParaCopiar");

            if (spanElement) {
                let newValue = spanElement.textContent.replace(/^\/\//, '');
                // Remove o // da exibição visual também
                spanElement.textContent = newValue;

                if (formButton) {
                    formButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        navigator.clipboard.writeText(newValue).then(() => {
                            formButton.textContent = "Copiado!";
                            formButton.classList.add("active");
                            faixCupom.classList.add("active");
                        }).catch(err => {
                            console.error('Erro ao copiar: ', err);
                            alert("Erro ao copiar o valor.");
                        });
                    });
                }
            }

            $('#faixa-cupom').slick({
                dots: false,
                arrows: false,
                autoplay: false,
                infinite: false,
                mobileFirst: true,
                speed: 1000,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
        }
    });

    var bannerHomeFull = $('.home__banner');
    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if(bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if(bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    } 

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if(firstCarrousel) {
            $('#product_list').slick({
                arrows: true,
                prevArrow: $(".product-list-arrows .prev"),
                nextArrow: $(".product-list-arrows .next"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const secondCarrousel = element.querySelector('#product_list-2');
        if(secondCarrousel) {
            $('#product_list-2').slick({
            arrows: true,
            prevArrow: $(".product-list-arrows .prev2"),
            nextArrow: $(".product-list-arrows .next2"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1249,
                    settings: {
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });

            $('#product_list-2').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.video-products').then(element => { 
        $('#carrousel-products-video').slick({
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        autoplay: true,
                        speed: 1000
                    }
                }
            ]
        });

        $('#carrousel-products-video').on('afterChange', function(event, slick, currentSlide, nextSlide){
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function(element) {
                    setTimeout(function(){
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const thirdCarrousel = element.querySelector('#product_list-3');
        if(thirdCarrousel) {
            $('#product_list-3').slick({
                arrows: true,
                prevArrow: $(".product-list-arrows .prev3"),
                nextArrow: $(".product-list-arrows .next3"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list-3').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    // waitForElementToExist('.banner-desconto__content').then(element => { 
    //     $('.banner-desconto__content').slick({
    //         arrows: false,
    //         dots: false,
    //         infinite: false,
    //         autoplay: true,
    //         mobileFirst: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         speed: 1000,
    //         responsive: [
    //             {
    //                 breakpoint: 991,
    //                 settings: 'unslick'
    //             }
    //         ]
    //     });
    // });

    waitForElementToExist('#brands-carousel').then(element => { 
        $('#brands-carousel').slick({
            arrows: false,
            dots: false,
            infinite: false,
            autoplay: true,
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        speed: 1500,
                    }
                },
            ]
        });
    });

    waitForElementToExist('#carrousel-banner-categories').then(element => { 
        $('#carrousel-banner-categories').slick({
            arrows: true,
            prevArrow: $(".text-content__arrow .prev"),
            nextArrow: $(".text-content__arrow .next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        speed: 1000,
                    }
                }
            ]
        });
    });
    
})